import { Helper } from '../Helper';
export class DeleteStorageBaseHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.cacheStorage);
        sb.emitOp(node, 'OVER');
        sb.emitOp(node, 'REMOVE');
        sb.emitHelper(node, options, sb.helpers.deleteCacheStorage);
        sb.emitOp(node, 'SWAP');
        sb.emitPushBoolean(node, true);
        sb.emitOp(node, 'SETITEM');
    }
}

//# sourceMappingURL=DeleteStorageBaseHelper.js.map
